import { useCallback } from 'react';
import { useCardsService } from './useCardsService';
import { Card } from '../types/card';

/**
 * Hook for search operations using the service-based architecture
 * This replaces the legacy useSearch hook
 */
export const useSearchService = () => {
  const { searchCards, isLoading, error } = useCardsService();

  /**
   * Search for cards by query string
   */
  const performSearch = useCallback(async (query: string): Promise<Card[]> => {
    if (!query || query.trim().length < 2) {
      return [];
    }

    const response = await searchCards(query.trim());
    return response || [];
  }, [searchCards]);

  return {
    isLoading,
    error,
    performSearch,
  };
};
